/**
 * Function to convert the given words (seperated by space)
 * to camelCase (words with index letter in capital without space)
 */
export function convertLabelToKey(label: string): string {
  // Convert the string to lowercase and split it into an array of words
  const words = label.toLowerCase().split(' ')

  // Capitalize the first letter of each word after the first one
  for (let i = 1; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
  }

  return words.join('')
}
